<template>
  <div class="row">
    <div
      v-if="$slots.items && $slots.items.length > adjustedItemsPerPage"
      class="col-12 col-lg-12"
    >
      <div
        ref="carouselContainer"
        class="list-item-carousel owl-carousel owl-theme owl-single-item"
      >
        <slot-component
          v-for="(item, index) in $slots.items"
          :key="index"
          :vnode="item"
        />
      </div>
    </div>
    <div
      v-for="(item, index) in $slots.items"
      v-else
      :key="index"
      class="col-6 col-md-4 col-lg-3 col-xl-2 mh-carousel-item"
    >
      <slot-component :vnode="item" />
    </div>
  </div>
</template>

<script>
import { isBreakpointDown, isBreakpointUp } from '../../helpers/device-size-check'

const observers = {}
export default {
    name: 'Carousel',
    components: {
        SlotComponent: {
            functional: true,
            render: (createElement, context) => context.data.attrs.vnode
        }
    },
    props: {
        itemsPerPage: {
            type: Number,
            default: 4
        },
        autoAdjustItemsPerPage: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            adjustedItemsPerPage: this.itemsPerPage
        }
    },
    mounted () {
        if (this.autoAdjustItemsPerPage) { this.adjustItemsPerPage() }
        this.$nextTick(() => {
            this.initializeCarousel()
            if (window.MutationObserver && this.$slots.items && this.$slots.items.length > this.adjustedItemsPerPage) {
                const observer = new MutationObserver(this.updateCarousel)
                observers[this._uid] = observer
                observer.observe(this.$refs.carouselContainer, { subtree: true, childList: true })
            }
        })
    },
    updated () {
        this.initializeCarousel()
    },
    methods:
            {
                updateCarousel (ev) {
                    ev.forEach(e => {
                        if (e.addedNodes[0] && e.addedNodes[0].tagName === 'IMG') {
                            const $owl = $(this.$refs.carouselContainer)
                            $owl.trigger('refresh.owl.carousel')
                            observers[this._uid].disconnect()
                        }
                    })
                },
                adjustItemsPerPage () {
                    if (isBreakpointUp('xxxxxl')) {
                        this.adjustedItemsPerPage = 8
                    } else if (isBreakpointUp('xxxxl')) {
                        this.adjustedItemsPerPage = 7
                    } else if (isBreakpointUp('xxxl')) {
                        this.adjustedItemsPerPage = 6
                    } else if (isBreakpointUp('xl')) {
                        this.adjustedItemsPerPage = 5
                    } else if (isBreakpointUp('lg')) {
                        this.adjustedItemsPerPage = 4
                    } else if (isBreakpointUp('md')) {
                        this.adjustedItemsPerPage = 3
                    } else {
                        this.adjustedItemsPerPage = 2
                    }
                },
                initializeCarousel () {
                    if (this.$slots.items && this.$slots.items[0].tag && this.$slots.items.length > this.adjustedItemsPerPage) {
                        const $owl = $(this.$refs.carouselContainer)
                        // do not render, if no html element is inside of the carousels container
                        if (!$owl.children().length) {
                            return
                        }
                        window._owlc().then(() => {
                            $owl.owlCarousel({
                                onInitialized() {
                                    $owl.find('.owl-carousel.owl-loaded').each(function () {
                                        $(this).trigger('refresh.owl.carousel')
                                    })
                                },
                                autoHeight: true,
                                dots: true,
                                items: this.itemsPerPage,
                                responsive: {
                                    0: {
                                        items: this.adjustedItemsPerPage
                                    },
                                    576: {
                                        items: this.adjustedItemsPerPage
                                    },
                                    768: {
                                        items: this.adjustedItemsPerPage
                                    },
                                    992: {
                                        items: this.adjustedItemsPerPage
                                    },
                                    1200: {
                                        items: this.adjustedItemsPerPage
                                    },
                                    1400: {
                                        items: this.adjustedItemsPerPage
                                    }
                                },
                                lazyLoad: false,
                                loop: false,
                                margin: isBreakpointDown('md') ? 14 : 30,
                                mouseDrag: true,
                                nav: true,
                                navClass: [
                                    'owl-single-item-nav left carousel-control list-control-special',
                                    'owl-single-item-nav right carousel-control list-control-special'
                                ],
                                navContainerClass: '',
                                navText: [
                                    '<i class="owl-single-item-control fa fa-chevron-left" aria-hidden="true"></i>',
                                    '<i class="owl-single-item-control fa fa-chevron-right" aria-hidden="true"></i>'
                                ],
                                smartSpeed: 350
                            })
                        })
                    }
                }
            }
}
</script>
